const features = require ('./featureToggleConstants.js');
const version_manager = require ('./version_manager.js');

define(function(require) {
	App.featureToggles = {};
	return {
		processGlobalConfigFeatureToggles: function(featureToggles){
			if(!featureToggles || !featureToggles.inactiveFeatures || !featureToggles.inactiveFeatures.length>0){
				//set a default so we don't error out. if we have no inactive features, then everything should be active.
				featureToggles = { inactiveFeatures:[]};
			}

			Object.keys(features).forEach((key)=>{
				let feature = features[key];
				let enabled = version_manager.versionRange(feature.versionFirstAvailable); // is our version newer than the toggle version?
				if(enabled){//if we're disabled by version checking, then we don't need to compare to the config response.
					featureToggles.inactiveFeatures.forEach(inactive => {//inactiveFeatures is an array of strings containing the feature toggle name
						if(feature.name === inactive){
							enabled = false;
						}
					});
				}
				App.featureToggles[key] = enabled;
			});

			//to access this, we should need to do App.featureToggles.AUTHORIZED_USERS anywhere in the code base.
		}
	};
});